import axios from "axios"
import { AIMLABS_HASURA_GRAPHQL_ENDPOINT } from "@/constants/util"

// TODO: Set up Vue Apollo Client for Aimlabs Hasura API
export const fetchAcceptedBounties = async ({ accessToken }) => {
  const res = await axios.post(AIMLABS_HASURA_GRAPHQL_ENDPOINT, {
    query: `
      query AcceptedBounties {
        acceptedBounties {
          id
          type
          submittingUser {
            id
            username
            profileImageUrl
          }
          gameId
          url
          value
          isPublic
          isAccepted
          isExpired
          metadata {
            height
            width
            duration
            altText
            imgPreviewUrl
          }
        }
      }
    `,
  }, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
    },
  })

  if (res.data.errors) {
    throw res.data.errors
  }

  return res.data.data?.acceptedBounties
}

export const fetchAvailableBounties = async ({ accessToken, limit, cursor }) => {
  const res = await axios.post(AIMLABS_HASURA_GRAPHQL_ENDPOINT, {
    query: `
      query AvailableBounties($limit: Int, $cursor: String) {
        publiclyAvailableBounties(limit: $limit, cursor: $cursor) {
          result {
            id
            type
            submittingUser {
              id
              username
              profileImageUrl
            }
            gameId
            url
            value
            isPublic
            isAccepted
            isExpired
            metadata {
              height
              width
              duration
              altText
              imgPreviewUrl
            }
          }
          nextCursor
        }
      }
    `,
    variables: {
      limit,
      cursor,
    },
  }, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
    },
  })

  if (res.data.errors) {
    throw res.data.errors
  }

  return res.data.data?.publiclyAvailableBounties
}

export const acceptBounty = async ({ accessToken, bountyId }) => {
  const res = await axios.post(AIMLABS_HASURA_GRAPHQL_ENDPOINT, {
    query: `
      mutation AcceptBounty($bountyId: String!) {
        acceptBounty(id: $bountyId) {
          id
          type
          submittingUser {
            id
            username
            profileImageUrl
          }
          gameId
          url
          value
          isPublic
          isAccepted
          isExpired
          offeredAmount
          metadata {
            height
            width
            duration
            altText
            imgPreviewUrl
          }
        }
      }
    `,
    variables: {
      bountyId,
    },
  }, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
    },
  })

  if (res.data.errors) {
    throw res.data.errors
  }

  return res.data.data?.acceptBounty
}

export const hideBounty = async ({ accessToken, bountyId }) => {
  const res = await axios.post(AIMLABS_HASURA_GRAPHQL_ENDPOINT, {
    query: `
      mutation HideBounty($bountyId: String!) {
        hideBounty(bountyId: $bountyId) {
          bountyId
        }
      }
    `,
    variables: {
      bountyId,
    },
  }, {
    headers: {
      "Authorization": `Bearer ${accessToken}`,
    },
  })

  if (res.data.errors) {
    throw res.data.errors
  }

  return res.data.data?.hideBounty
}

export const getVideoFileAccessCookie = async (pipelineId) => {
  const res = await axios.post(AIMLABS_HASURA_GRAPHQL_ENDPOINT, {
    query: `
      query videoCookie($pipelineId: ID!) {
        videoCookie(pipelineId: $pipelineId)
      }
    `,
    variables: { pipelineId },
  })

  if (res.data.errors) {
    throw res.data.errors
  }

  return res.data.data?.videoCookie
}

export const getVideoFileSignature = async (pipelineId) => {
  const res = await axios.post(AIMLABS_HASURA_GRAPHQL_ENDPOINT, {
    query: `
      query signedVideoUrl($pipelineId: ID!) {
        signedVideoUrl(pipelineId: $pipelineId) {
          signature
        }
      }
    `,
    variables: { pipelineId },
  })

  if (res.data.errors) {
    throw res.data.errors
  }

  return res.data.data?.signedVideoUrl?.signature
}

// TODO: Load game data from bounty query resolver instead
export const fetchGameById = async (id) => {
  const res = await axios.post(AIMLABS_HASURA_GRAPHQL_ENDPOINT, {
    query: `
      query GameById($id: String!) {
        pgGameByPk(id: $id) {
          id
          name
          description
          genre
          tag
        }
      }
    `,
    variables: { id },
  })

  if (res.data.errors) {
    throw res.data.errors
  }

  return res.data.data?.pgGameByPk
}



// WEBPACK FOOTER //
// ./src/store/coach/dashboard/aimlabs-marketplace/bounties/bounties.apis.js